import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";
import { RequirementType } from "@wingspanhq/payments/dist/interfaces";

export const REQUIREMENTS_WITH_ERRORS: Record<RequirementType, boolean> = {
  [RequirementType.SharedFile]: false,
  [RequirementType.Signature]: false,
  [RequirementType.IdentityVerification]: true,
  [RequirementType.BackgroundCheck]: true,
  [RequirementType.InsuranceCoverage]: false,
  [RequirementType.Registration]: false,
  [RequirementType.TaxVerification]: false,
  [RequirementType.PayoutMethod]: false
};

export const convertFormApprovalDataToReviewStrategy = (payload: {
  isApprovalRequired: boolean;
  reviewStrategy?: RequirementReviewStrategy;
  type: RequirementType;
}): RequirementReviewStrategy => {
  const simpleReviewStrategy = payload.isApprovalRequired
    ? RequirementReviewStrategy.AlwaysRequired
    : RequirementReviewStrategy.NeverRequired;

  const withErrorsReviewStrategy = payload.reviewStrategy
    ? payload.reviewStrategy
    : RequirementReviewStrategy.NeverRequired;

  if (REQUIREMENTS_WITH_ERRORS[payload.type]) {
    return withErrorsReviewStrategy;
  } else {
    return simpleReviewStrategy;
  }
};

export const REVIEW_STRATEGY_ON_FAIL_COPY =
  "Only require when there are flags for review or validations fail (auto-approve if passed)";
export const REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY =
  "Always require (every submission)";
export const REVIEW_STRATEGY_NEVER_REQUIRED_COPY =
  "Never require (approval step is skipped)";
